import { render, staticRenderFns } from "./RefreshComponent.vue?vue&type=template&id=2e51220e"
import script from "./RefreshComponent.vue?vue&type=script&lang=js"
export * from "./RefreshComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports